import { render, staticRenderFns } from "./PurchaseRejected.vue?vue&type=template&id=57fafcca&scoped=true"
import script from "./PurchaseRejected.vue?vue&type=script&lang=js"
export * from "./PurchaseRejected.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRejected.vue?vue&type=style&index=0&id=57fafcca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fafcca",
  null
  
)

export default component.exports